<template>
    <div class="lms__superadmin_customer_contact_edit">
        <div class="lms__superadmin_customer_contact_edit_header">
            <view-actions
                :title="`${this.$t('lms.customer.viwAction.titleName')} ${contactName}`"
                :notify-title="$t('lms.customer.viwAction.notifyTitle')"
                :notify-process="$t('lms.customer.viwAction.cancelButtonText')"
                :cancel-button-text="$t('lms.customer.viwAction.cancelButtonText')"
                :submit-button-active="false"
                :trash-button-active="true"
                :breadcrumb-active="true"
                :breadcrumb-items="[
                    {
                        name: customerName,
                        to: customerTo
                    }
                ]"
                @emit-notify-remove-submit="contactRemove"
                @emit-notify-cancel-submit="contactStopEdit"
            />
        </div>
        <div class="lms__superadmin_customer_contact_edit_main">
            <div class="container">
                <div class="columns custom--centered">
                    <div class="column is-5-desktop is-7-tablet is-12-mobile">
                        <lms-superadmin-customer-contact-edit-form ref="dashboardcustomercontacteditform"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import LmsSuperadminCustomerContactEditForm from '@/components/lms/superadmin/customer/contact/edit/LmsSuperadminCustomerContactEditForm'

export default {
  components: {
    LmsSuperadminCustomerContactEditForm,
    ViewActions
  },
  name: 'lms-superadmin-customer-contact-edit',
  computed: {
    contactName: function () {
      return this.$store.getters.getLmsSuperadminCustomerContactName
    },
    customerId: function () {
      return this.$store.getters.getLmsSuperadminCustomerId
    },
    customerName: function () {
      return this.$store.getters.getLmsSuperadminCustomerName
    },
    customerTo: function () {
      return { name: 'lms-superadmin-customer-edit-contacts', params: { id: this.customerId } }
    }
  },
  methods: {
    allowRedirectBeforeRouteLeave: function () {
      this.$eventBus.$emit('customer-contact-submit')
    },
    //
    contactRemove: function () {
      this.allowRedirectBeforeRouteLeave()
      this.$refs.dashboardcustomercontacteditform.$validator.pause()
      this.$store.dispatch('lmsSuperadminCustomerContactRemove')
    },
    contactStopEdit: function () {
      const customerId = String(this.customerId)
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'lms-superadmin-customer-edit-contacts', params: { id: customerId } })
      this.$store.dispatch('lmsSuperadminCustomerContactReset')
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/customers/contacts/_lmssuperadmincustomercontactaddedit.scss";
</style>
